export default __webpack_public_path__ + "static/media/studying.40450d9f.png";